module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/trading-07a587cfc29b410865b5b71454718462.png";